import React, { useState } from 'react'
import { IProps } from './index'
import { RecordedWebinarsCategory } from './category'
import { Text } from 'marketing-site/src/library/elements/Text'
import { DropDown } from 'marketing-site/src/library/elements/DropDown'
import { Search } from 'marketing-site/src/library/elements/Search'
import { CheckBox } from 'marketing-site/src/library/elements/CheckBox'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { IWebinarCategory } from './index'
import styles from './styles.scss'
import useTranslate from 'marketing-site/src/library/hooks/useTranslate'

export function RecordedWebinars({ heading, webinars, categories, searchEnabled }: IProps) {
  const [search, setSearch] = useState<string>('')
  const [currentCategories, setCurrentCategories] = useState<IWebinarCategory[]>(categories || [])
  const { translate } = useTranslate()

  const filteredResults = webinars.filter((webinar) => {
    const hasCategory = currentCategories.some((category) =>
      webinar.categories.includes(category.title),
    )
    const descriptionString = webinar.description && documentToHtmlString(webinar.description)
    const titleAndDescription =
      `${webinar.title} ${webinar.subtitle} ${descriptionString}`.toLowerCase()
    const hasKeywords = titleAndDescription.includes(search.trim().toLowerCase())
    return hasCategory && hasKeywords
  })

  function toggleCategory(category: IWebinarCategory, checked: boolean) {
    const newCategories = currentCategories.map((cat) => {
      cat.active = cat.title === category.title ? checked : cat.active
      return cat
    })
    setCurrentCategories(newCategories)
  }

  function renderWebinarsByCategory() {
    const filteredCategories = currentCategories
      .map((category, index) => {
        const filteredWebinars = filteredResults.filter((item) =>
          item.categories.includes(category.title),
        )
        if (category.active && filteredWebinars.length > 0) {
          return (
            <RecordedWebinarsCategory
              category={category.title}
              key={index}
              webinars={filteredWebinars}
            />
          )
        }
      })
      .filter(Boolean)

    return filteredCategories.length > 0 ? (
      filteredCategories
    ) : (
      <Text brand="default" size="heading-4">
        {translate('No Results Found')}
      </Text>
    )
  }

  return (
    <section className="recorded-webinars">
      <div className="recorded-webinars__header">
        <h2 className="recorded-webinars__heading">
          <Text brand="default" size="heading-2">
            {heading}
          </Text>
        </h2>
        <div className="recorded-webinars__right-header">
          {categories && (
            <div className="recorded-webinars__dropdown">
              <p>{translate('Filter:')}</p>
              <DropDown label="Category">
                <ul role="listbox">
                  {categories.map((cat, index) => (
                    // eslint-disable-next-line
                    <li role="option" key={index}>
                      <CheckBox
                        label={cat.title}
                        checked={cat.active}
                        onChange={(checked: boolean) => toggleCategory(cat, checked)}
                      />
                    </li>
                  ))}
                </ul>
              </DropDown>
            </div>
          )}
          {searchEnabled && (
            <div className="recorded-webinars__search">
              <Search value={search} handleSearch={setSearch} />
            </div>
          )}
        </div>
      </div>
      {/* If we are on the hub page and are utilizing categories */}
      {currentCategories.length > 0 ? (
        renderWebinarsByCategory()
      ) : (
        <RecordedWebinarsCategory webinars={webinars} />
      )}
      <style jsx>{styles}</style>
    </section>
  )
}
